module.exports = __webpack_public_path__ + "static/img/bg52.2c092241.png";